

















































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from "@/content/5-components/Button.vue"
import JdhStructuralButton from "@/design-system/shared/structural/JdhStructuralButton.vue"

@Component({
    components: {JdhStructuralButton, Button}
})
export default class JdpTestSettings extends Vue {
}
